<template>
    <div :class="[{ 'o-popups-container--click-transparent': hasCameraUpdatedRecently }, 'o-popups-container']">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LabelsContainer',
    inject:['mapViewer'],
    props:{
        height: {type:String, default:'100vh'},
    },
    data(){
        return{
            hasCameraUpdatedRecently: false,
            cameraUpdateTimeout: null,
            cameraUpdateTimeoutDelay: 500,
        }
    },
    methods:{
        handleCameraUpdate() {
            clearTimeout(this.cameraUpdateTimeout);
            this.hasCameraUpdatedRecently = true;
            this.cameraUpdateTimeout = setTimeout(() => {
                this.hasCameraUpdatedRecently = false
            }, this.cameraUpdateTimeoutDelay)
        },
    },
    updated(){
    },
    mounted(){
        this.$bus.$on('map:ready', () => {
            this.mapViewer.viewApi.register_event('on_camera_update', this.handleCameraUpdate);
        });
    },
    beforeDestroy(){
        this.mapViewer.viewApi.deregister_event('on_camera_update', this.handleCameraUpdate);
    }
}
</script>

<style lang="scss">
  .o-popups-container{
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    &--click-transparent{
      .m-unit-info{
        pointer-events: none;
        cursor: default;
      }
    }
  }
</style>
